module.exports = __webpack_public_path__ + "img/berlin.61089402.svg";